import { Language } from "@faire/web-api/indigofair/languages/Language";
import { HELP_CENTER_CHAT_AVAILABLE_LOCALES } from "@faire/web-api/indigofair/settings/HELP_CENTER_CHAT_AVAILABLE_LOCALES";
import { getSettingValueWithoutAssignment } from "./getSetting";
export var getSettingHelpCenterChatAvailableLocales = function getSettingHelpCenterChatAvailableLocales() {
  return getSettingValueWithoutAssignment(HELP_CENTER_CHAT_AVAILABLE_LOCALES, [{
    language: Language.ENG,
    country: undefined
  }]);
};